import { ApiService } from '../../core/services/api'
import { User } from '@/modules/core/models'
import { Dictionary } from 'vuex'
import {store} from "@/modules/store/store-module";

const UserService = {

  create: async function (user:User) {
    const requestData = {
      method: 'POST',
      url: 'user/users/create_user/',
      header: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: user.toJson()
    };

    try {
      const response = await ApiService.customRequest(requestData)

      await store.dispatch("auth/login", {email: user.email, password: user.password!});

      user = User.fromJson(response['data']);
      return user
    } catch (exception) {
      console.error('error while creating user')
      //throw new AuthenticationError(exception.response.status, exception.response.data.detail)
    }
  },

  list: async function (page: Number, size: Number, filters?: Dictionary<any>): Promise<[Array<User>, number]> {
    try{
      const response = await ApiService.get('user/users/', { 'page': page, 'page_size': size })

      let listUsers : Array<User> = [];
      for (let json of response.data.results) {
        let user = User.fromJson(json) as User;
        listUsers.push(user)
      }
      return [listUsers, response.data.count]
    }catch (exception) {
      store.dispatch("snackbar/activate", {message: "Upps, parece que ha sucedido un error, pruebe mas tarde", code: 1} );
    }

  },

  get: async function (pk: Number, filters?: Dictionary<any>): Promise<User> {
    const response = await ApiService.get(`user/users/${pk}/`);

    let user : User = User.fromJson(response.data) as User;
    return user;
  },

  get_current_user: async function (): Promise<User> {
    try{
      const response = await ApiService.get(`user/users/current_user/`);
      let user : User = User.fromJson(response.data) as User;
      return user;
    }catch (exception) {
      store.dispatch("snackbar/activate", {message: "Upps, parece que ha sucedido un error, pruebe mas tarde", code: 1} );
    }
  },

  patch: async function (pk: Number, data: JSON, filters?: Dictionary<any>): Promise<User> {
    const response = await ApiService.patch(`user/users/${pk}/`, data);

    let user : User = User.fromJson(response.data) as User;
    return user;
  }
}

export { UserService }
